export default "__VITE_ASSET__ZPJtt301__"